import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Navbar from './components/NavBar';
import Footer from './components/footer';
import ShopifyDevelopment from './pages/ShopifyDevelopment';  
import SEO from './pages/SEO';
import EmailSMSMarketing from './pages/Email&SMS';
import FBGoogleAds from './pages/FB&GoogleAds';
import ContentStrategy from './pages/ContentStrategy';
import WhyGroviyo from './pages/WhyGroviyo';
import ServicesPage from './pages/Services';
import Contact from './pages/Contact';

const App: React.FC = () => {
 return (
   <BrowserRouter>
     <div className="App">
       <Navbar />
       
       <Routes>
         <Route path="/" element={<Home />} />
         <Route path="/about" element={<About />} />
         <Route path="/shopify" element={<ShopifyDevelopment />} />
         <Route path="/seo" element={<SEO />} />
         <Route path="/email" element={<EmailSMSMarketing />} />
         <Route path="/fb" element={<FBGoogleAds />} />
         <Route path="/strategy" element={<ContentStrategy />} />
         <Route path="/why" element={<WhyGroviyo />} />
         <Route path="/services" element={<ServicesPage />} />
         <Route path="/contact" element={<Contact />} />
       </Routes>
       <Footer />
     </div>

   </BrowserRouter>
  
 );
};

export default App;